<!-- =========================================================================================
  File Name: ExhibitorList.vue
  Description: Exhibitor List Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
.popup-info-tooltips {
  z-index: 99999;
  height: 297px;
}
.popup-info-tooltips.info-top-custom-tooltip {
  top: -300px !important;
  right: 0;
}
.option-inner-wrap {
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.option-inner-wrap li {
  list-style: none;
  width: 50%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 10px;
}
</style>
<template>
  <div id="page-user-list" v-show="pageLoaded">
    <div class="header-custome">
      <h3>
        Exhibitors
        <span>{{
          gridSelectedRows ? "(Rows Selected: " + gridSelectedRows + ")" : ""
        }}</span>
      </h3>
      <div class="knowlg-base-wrap-sec hidden">
        <a href="/pages/knowledge-base/category-exhibitors/question-3">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-help-circle"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </span>
          Need help with this section?
        </a>
      </div>
    </div>

    <div
      class="vx-card p-6 blank-attendee"
      v-show="usersData.length < 1"
    >
      <div class="entity-create-sec">
        <div class="emtity-icon">
          <!--<feather-icon class="" icon="LayoutIcon" />-->
          <img src="../../assets/images/blank-page-images/exhibitor.png"/>
        </div>
        <div class="entity-create-desc">
          <h2>Create an Exhibitor</h2>
          <p>The Expo area is the exhibitor hall of digital vendor booths at your event. You can choose from 3 different types of Expo Halls and from more than 12+ booth design templates so that attendees can visit the booths that interest them, network, and take action.</p>
          <div class="entity-setup-buttons">
            <vs-button color="primary" type="border" @click="getDefaultSettings"
              >ADVANCED SETTINGS</vs-button
            >
            <vs-button
              color="primary"
              type="filled"
              class="new-entity-add-button"
              @click="$router.push('/event/exhibitor/add')"
              >ADD NEW EXHIBITORS</vs-button
            >
            <vs-button
              color="primary"
              type="border"
              class="new-entity-add-button"
              @click="popupActive = true"
              >IMPORT EXHIBITORS</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Role</label>
          <v-select :options="roleOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="roleFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Status</label>
          <v-select :options="statusOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Verified</label>
          <v-select :options="isVerifiedOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="isVerifiedFilter" class="mb-4 sm:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Department</label>
          <v-select :options="departmentOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="departmentFilter" />
        </div>
      </div>
    </vx-card>-->

    <div
      class="vx-card p-6"
      v-show="usersData.length > 0"
    >
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }}
                -
                {{
                  usersData.length - currentPage * paginationPageSize > 0
                    ? currentPage * paginationPageSize
                    : usersData.length
                }}
                of {{ usersData.length }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <span id="exhibitorCount" style="display: none">{{
              usersData.length
            }}</span>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- <vs-button type="border mr-4" v-on:click="ManageCategory()"
          >Manage Categories</vs-button
        > -->
        <vs-dropdown class="border cursor-pointer" vs-custom-content vs-trigger-click>
          <div class="p-3 mr-4 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-50">
            <span>Manage</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4 ml-1" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item>
              <span class="block p-3 cursor-pointer" v-on:click="ManageCategory()">Booth Template</span>
            </vs-dropdown-item>
            <vs-dropdown-item>
              <span class="block p-3 cursor-pointer" v-on:click="ManageBoothType()">Booth Type</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!--ADD -->
        <vx-tooltip text="Send mail to Exhibitors" position="bottom">
          <vs-button type="border mr-4" @click="getMailTpl"
            >Send Mail</vs-button
          >
        </vx-tooltip>
        
        <vs-button class="mr-4" color="rgb(76, 139, 246)" type="filled" v-on:click="addRecord()"
          >Create Exhibitors</vs-button
        >
        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="changeStatus(true)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Set Active</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item @click="changeStatus(false)">
              <span class="flex items-center">
                <feather-icon
                  icon="ArchiveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Set Inactive</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="exportChat(true)">
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Chat Export</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="OpenExhibitorExportModal">
              <span class="flex items-center">
                <feather-icon
                  icon="SaveIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Exhibitor Reports</span>
              </span>
            </vs-dropdown-item>
            <!--
              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>
            -->
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-button
          color="primary"
          type="border"
          class="ml-3"
          @click="popupActive = true"
          >Import</vs-button
        >
        <vs-popup
          class="holamundo"
          title="Import Exhibitor"
          :active.sync="popupActive"
        >
          <div class="import-attendee-wrapper">
            <div class="template-download">
              <h4>Download the template</h4>
              <a
                color="primary"
                type="filled"
                class="mt-3 btn"
                href="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDownloads%2FTemplate_Exhibitor.xlsx?alt=media&token=af0ac634-c0d2-4034-baec-1e552285635f"
                >Download</a
              >
            </div>
            <!--
              <div class="add-content mt-5">
                <h4>Add content</h4>
                <p>Add content to the template. Please don’t delete or rename columns, leave them empty if unused.</p>
              </div>
            -->
            <div class="upload-file mt-5">
              <h4>Upload your file</h4>
              <div class="file-up-section">
                <p>Select XLSX file</p>
                <input
                  type="file"
                  id="exhibitor_file"
                  accept=".csv, .xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                <vs-button
                  color="rgb(76, 139, 246)" type="filled"
                  class="sub-btn"
                  v-on:click="UploadExhibitor"
                  >Upload</vs-button
                >
              </div>
            </div>
          </div>
        </vs-popup>
        <vs-button
          color="primary"
          type="border"
          class="ml-3 setting-btn"
          @click="getSettings"
        >
          <img src="../../assets/images/settings.svg" alt="settings" />
        </vs-button>

        <!-- Exhibitor Category -->
        <vs-popup
          class="holamundo exhibitor-category-popup"
          title="Template Style Gallery"
          :active.sync="popupActiveCategory"
        >
          <div class="vx-col w-full text-right mb-5">
            <vs-button color="success" type="gradient" @click="addCategory()"
              >Add New</vs-button
            >
          </div>

          <div class="flex flex-wrap items-center">
            <div class="flex-grow">
              <!-- AG GRID CAtegory -->
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2"
                    >{{
                      currentPageCategory * paginationPageSizeCategory -
                      (paginationPageSizeCategory - 1)
                    }}
                    -
                    {{
                      categoryList.length -
                        currentPageCategory * paginationPageSizeCategory >
                      0
                        ? currentPageCategory * paginationPageSizeCategory
                        : categoryList.length
                    }}
                    of {{ categoryList.length }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="gridCategoryApi.paginationSetPageSize(10)"
                  >
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="gridCategoryApi.paginationSetPageSize(20)"
                  >
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="gridCategoryApi.paginationSetPageSize(25)"
                  >
                    <span>25</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="gridCategoryApi.paginationSetPageSize(30)"
                  >
                    <span>30</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <ag-grid-vue
                ref="agGridCategory"
                :components="components"
                :gridOptions="gridOptionsCategory"
                class="ag-theme-material w-full my-4 ag-grid-table"
                :columnDefs="columnDefsCategory"
                :defaultColDef="defaultColDefCategory"
                :rowData="categoryList"
                rowSelection="multiple"
                colResizeDefault="shift"
                :animateRows="true"
                :floatingFilter="true"
                :pagination="true"
                :paginationPageSize="paginationPageSizeCategory"
                :suppressPaginationPanel="true"
                :enableRtl="$vs.rtl"
              ></ag-grid-vue>
              <vs-pagination
                :total="totalPagesCategory"
                :max="7"
                v-model="currentPageCategory"
              />
              <!-- AG GRID CAtegory Ends-->
            </div>
          </div>
        </vs-popup>
        <!-- Exhibitor Category Ends-->
        <!-- Exhibitor Add Category -->
        <vs-popup
          class="holamundo add-template"
          title="Add New Template"
          :active.sync="popupActiveAddCategory"
        >
          <vs-input
            label="Template Name"
            class="mt-5 w-full"
            name="CategoryName"
            v-model="categoryName"
            data-vv-as="Category Name"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('CategoryName')"
            >{{ errors.first("CategoryName") }}</span
          >
          <!-- <input
            type="text"
            value
            id="txtCategory"
            placeholder="Search Keywords or multiple keywords separated by comma"
            data-tag="profileTagSearch"
          />-->
          <br />
          <span>Select Style</span>
          <!--<select  v-model="data_local.MapTo.Entity">
            <option
              v-for="group in templateData"
              v-bind:key="group.id"
              :value="group.templateName"
              data-tag="Categorytemplate"
            >{{group.templateName}}</option>
          </select>-->
          <v-select
            class="mt-3"
            name="template"
            v-model="exhTemplate"
            label="templateName"
            :options="templateData"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('template')">{{
            errors.first("template")
          }}</span>
          <br />
          <div class="category-carousel">
            <div class="carousel-example">
              <swiper
                :options="swiperOption"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :key="$vs.rtl"
              >
                <swiper-slide
                  class="sinle-slider-image"
                  v-show="group.ImagePath"
                  v-for="group in templateData"
                >
                  <img class="responsive" :src="group.ImagePath" alt="banner" />
                  <vs-radio
                    v-model="exhTemplate"
                    :vs-value="group"
                    class="checkbox-on-img"
                  ></vs-radio>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </div>
          </div>
          <br />
          <vs-button class="mr-6" v-on:click="validateBeforeTemplateSave"
            >Submit</vs-button
          >
          <vs-button
            type="border"
            color="danger"
            @click="popupActiveAddCategory = false"
            >Cancel</vs-button
          >
        </vs-popup>
        <!-- Exhibitor Category Ends-->
      </div>

      <vs-popup
        class="holamundo"
        title="Export Exhibitor Report"
        :active.sync="popupActiveExhibitorExport"
      >
        <div class="import-attendee-wrapper">
          <div class="template-download">
            <h4 id="modalExhibitorSelected">Exhibitors Selected : 0</h4>
            <br />
            <hr />
          </div>
          <br />
          <div class="upload-file mt-5">
            <vs-button
              color="rgb(76, 139, 246)" type="filled"
              class="sub-btn"
              v-on:click="fetchExhibitorVisitorList()"
              >Exhibitor Visits</vs-button
            >&nbsp;
          </div>
        </div>
      </vs-popup>
      <vs-popup
      :title="popupAddTypeTitle"
      :active.sync="popupAddType"
      >
        <type-form :key="componentKey" v-if="ExhibitorType" :data="ExhibitorType" @closePopup="popupAddType=false" />
      </vs-popup>
      <vs-popup
      class="holamundo"
      title="Exhbitor Type List"
      :active.sync="popupExhibitorTypeList"
      >
        <div
          class="vx-col flex justify-content-between align-items-center w-full text-right mb-5 event-admin-popup-header"
        >       
          <vs-button
            class="ml-auto"
            @click="getExhibitorType(null)"
            >Add New</vs-button
          >        
        </div>
        <div class="flex flex-wrap">
          <div class="flex-grow">
            <div>
              <vs-table :data="exhibitorTypes">
                <template slot="thead"> 
                  <vs-th>Type Name</vs-th>
                  <vs-th>Background Image</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data"> 
                    <vs-td>{{
                      data[indextr].TypeName
                    }}</vs-td>
                    <vs-td>
                      <img v-if="data[indextr].BackgroundImg" :src="data[indextr].BackgroundImg" class="w-10 h-10" />
                    </vs-td>                  
                    <vs-td :data="data[indextr].TypeId">
                      <feather-icon
                        icon="EditIcon"
                        title="Edit"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                        @click="
                          getExhibitorType(
                            data[indextr]                       
                          )
                        "
                      />                    
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </vs-popup>
      <vs-popup
          mailpopup
          class="holamundo customnewpopup"
          title="Mail Preview"
          :active.sync="popupActiveMail"
        >
          <vs-tabs>
            <vs-tab label="Preview">
              <div class="tab-text">
                <div class="vx-row" style="width: 622px">
                  <div class="vx-col md:w-1/1 w-full mt-4">
                    <h3>Subject: {{ welcomeMailSubject }}</h3>
                  </div>
                  <br />
                  <div v-html="sourcehtml"></div>
                  <!--<quill-editor v-model="welcomeMailText"></quill-editor>-->
                  <br />
                  <div class="vx-col md:w-1/1 w-full mt-4">
                    <div click="sendbtn-section">
                      <vs-button
                        color="rgb(76, 139, 246)" type="filled"
                        @click="popupActiveMail = false"
                        >Cancel</vs-button
                      >
                      <vs-button
                        class="mail-btn"
                        color="rgb(76, 139, 246)" type="filled"
                        @click="sendMail"
                        >Send Mail</vs-button
                      >
                    </div>
                  </div>
                </div>
              </div>    
            </vs-tab>
            <vs-tab label="Edit">
              <vs-input
                class="inputx w-full mb-2"
                label="Subject"
                v-model="welcomeMailSubject"
              />
              <ckeditor
                class="desc-event mb-2"
                v-model="sourcehtml"
                :config="editorConfig"
              ></ckeditor>
              <div click="sendbtn-section">
                <vs-button
                  color="rgb(76, 139, 246)" type="filled"
                  @click="popupActiveMail = false"
                  >Cancel</vs-button
                >
                <vs-button
                  class="mail-btn"
                  color="rgb(76, 139, 246)" type="filled"
                  @click="saveMail"
                  >Save</vs-button
                >
              </div>
            </vs-tab>
          </vs-tabs>        
        </vs-popup>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        rowMultiSelectWithClick="false"
        suppressRowClickSelection="true"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
    <div v-if="popupActive2 == true">
      <exhibitor-settings
        :data="popupActive2"
        :key="exhibitorSettingsResetKey"
        v-on:saveExhibitorSettingsData="saveExhibitorSettingsData"
      />
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

// Store Module
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import moduleExhibitorManagement from "@/store/exhibitor-management/moduleExhibitorManagement.js";
import moduleroundtableManagement from "@/store/roundtable-management/moduleRoundtableManagement.js";
import bu from "@/store/bulkupload/BulkUpload.js";
import moment from "moment-timezone";
// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererExport from "./cell-renderer/CellRendererExport.vue";
import ExhibitorSettings from "./ExhibitorSettings.vue";
import TypeForm from "./TypeForm.vue";

//import CategoryCellRendererActions from "./cell-renderer/CategoryCellRendererActions.vue";
let Session_Event_TZ = ls.getSessionValueByKey("Session_Event_TZ");
import ls from "@/common/localStorage";
import con from "@/firebase/firebaseInit.ts";
//console.log(db);
import { AgGridVueCategory } from "ag-grid-vue";
import vSelectCategory from "vue-select";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";
var vm;
export default {
  components: {
    AgGridVue,
    vSelect,
    swiper,
    swiperSlide,
    quillEditor,
    ckeditor: CKEditor.component,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRendererExport,
    AgGridVueCategory,
    vSelectCategory,
    ExhibitorSettings,
    TypeForm,
    // CategoryCellRendererActions,
  },
  componentsCategory: {
    //----------------------------
    // AgGridVueCategory,
    // vSelectCategory,
    // Cell Renderer categtory
    // CellRendererLinkCategory,
    // CellRendererStatusCategory,
    // CellRendererVerifiedCategory,
    // CategoryCellRendererActions,
  },

  data() {
    return {
      // totalPagesCategory: 0,
      //currentPageCategory: 0,
      editorConfig: CKconfig.editorConfig,
      data_local: {},
      popupActiveExhibitorExport: false,
      CategoryData: [],
      categoryList: [],
      categoryName: "",
      exhTemplate: {},
      templateData: [],
      orderByExhibitor: "BoothNo",
      popupActiveCategory: false,
      popupActiveAddCategory: false,
      addNewDataSidebar: false,
      settingsData: { IsEnhancedHotspotting: false },
      pageLoaded: false,
      expoBoothRadios: "default",
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" },
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" },
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" },
      ],
      IsDefaultSettings: false,
      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      exhibitorSettingsResetKey: 0,
      // AgGrid
      gridApi: null,
      gridSelectedRows: 0,
      gridCategoryApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      defaultColDefCategory: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      gridOptionsCategory: {},
      ExpoHallBackgroundImageFile: null,
      ExpoHallBackgroundImageSrc: null,
      JoinTheConversationTexDefault:
        "Welcome to {BoothName} Our Reps are here to assist you. You can also contact us on {phone} or visit {BoothWebsite}",
      ExhibitorList: [],
      columnDefs: [
        {
          //headerName: 'ID',
          //field: 'id',
          width: 50,
          checkboxSelection: true,
          filter: false,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: "left",
        },
        // {
        //   headerName: "Id",
        //   field: "ExhibitorId",
        //   filter: true,
        //   width: 150,
        //   pinned: "left",
        // },
        {
          headerName: "Name",
          field: "Name",
          filter: true,
          width: 300,
          pinned: "left",
        },
        {
          headerName: "Email",
          field: "Email",
          filter: true,
          width: 200,
        },
        {
          headerName: "Phone",
          field: "Phone",
          filter: true,
          width: 140,
        },
        //{
        //  headerName: "Created Date",
        //  field: "CreatedDate",
        //  cellRenderer: data => {
        //    //return data.value.seconds ? this.GetDateTimeFromSeconds(data.value.seconds) : '';
        //    return data.value ? this.GetDateTimeFromSeconds(data.value) : "";
        //  },
        //  filter: true,
        //  width: 180
        //},
        {
          headerName: "Booth #",
          field: "BoothNo",
          filter: true,
          width: 120,
        },
        // {
        //   headerName: 'Verified',
        //   field: 'is_verified',
        //   filter: true,
        //   width: 125,
        //   cellRendererFramework: 'CellRendererVerified',
        //   cellClass: 'text-center'
        // },
        {
          headerName: "Booth Type",
          field: "Website",
          filter: true,
          width: 250,
        },
        {
          headerName: "Template Style",
          field: "Category",
          filter: true,
          width: 250,
        },
        {
          headerName: "Last Updated",
          field: "LastModifiedDate",
          cellRenderer: (data) => {
            //return data.value ? this.GetDateTimeFromSeconds(data.value.seconds) : '';
            return data.value
              ? this.SetTimeByZoneAMPM(
                  new Date(data.value.seconds * 1000).toUTCString(),
                  Session_Event_TZ
                )
              : "";
          },
          filter: true,
          width: 220,
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return { id: params.data.ExhibitorId };
          },
        },
        {
          headerName: "Status",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererStatus",
          cellRendererParams: (params) => {
            return { id: params.data.ExhibitorId };
          },
        },
        {
          headerName: "Export",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererExport",
          cellRendererParams: (params) => {
            return params;
          },
        },
      ],

      columnDefsCategory: [
        {
          headerName: "Template",
          field: "Category",
          filter: true,
          // width: 200,
        },
        {
          headerName: "Booth Style",
          field: "TemplateName",
          filter: true,
          // width: 200,
        },
        {
          headerName: "Last Modified",
          field: "LastModified",
          filter: true,
          // width: 200,
        },
        // {
        //   headerName: "Actions",
        //   field: "transactions",
        //   //  width: 100,
        //   //  cellRendererFramework: "CategoryCellRendererActions",
        //   cellRendererParams: (params) => {
        //     return { id: params.data.Category };
        //   },
        // },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
        CellRendererExport,
        AgGridVueCategory,
        vSelectCategory,
        // CategoryCellRendererActions,
      },
      // componentsCategory: {
      //   //----------------------------
      //   AgGridVueCategory,
      //   vSelectCategory,

      //   // Cell Renderer categtory
      //   // CellRendererLinkCategory,
      //   // CellRendererStatusCategory,
      //   // CellRendererVerifiedCategory,
      //   CategoryCellRendererActions,
      // },
      checkBox1: true,
      checkBox2: false,
      checkBox3: true,
      checkBox4: false,
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        cycle: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      popupAddType: false,
      popupAddTypeTitle: "Add Exhibitor Type",
      ExhibitorType: null,
      popupExhibitorTypeList: false,
      componentKey: 0,
      welcomeMailText: null,
      welcomeMailSubject: null,
      mailRecepients: [],
      sourcehtml: null,
      popupActiveMail: false,
    };
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value);
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    },
  },
  computed: {
    usersData() {
      return this.$store.state.exhibitorManagement.exhibitors;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    paginationPageSizeCategory() {
      if (this.gridCategoryApi)
        return this.gridCategoryApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    totalPagesCategory() {
      if (this.gridCategoryApi)
        return this.gridCategoryApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    currentPageCategory: {
      get() {
        if (this.gridCategoryApi)
          return this.gridCategoryApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridCategoryApi.paginationGoToPage(val - 1);
      },
    },
    exhibitorTypes () {
      return this.$store.state.exhibitorManagement.exhibitortypes;
    },
  },
  methods: {
    SetTimeByZoneAMPM: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    exportChat() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      debugger;
      console.log(selectedRows);
      var cn = ls.getSessionEventCollectionName();
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      console.log(cn);

      if (selectedRows.length > 0) {
        selectedRows.map((row) => {
          var mappedContcts = row.MappedContacts;
          for (var i = 0; i < mappedContcts.length; i++) {
            console.log(
              "chatCollection:- " +
                row.ExhibitorId +
                "_" +
                mappedContcts[i].AttendeeId +
                "_e2o"
            );
            var DocId =
              row.ExhibitorId + "_" + mappedContcts[i].AttendeeId + "_e2o";

            //----------------------------------------------------------------------------------

            var ref = con.eventDB
              .collection(cn)
              .doc("UserVideoActivity")
              .collection("ExhibitorMeeting")
              .doc(DocId)
              .collection("Chat");
            console.log(ref);
            //----------------------------------------------------------------------------------
            ref.get().then((querySnapshot) => {
              var datarow = [];

              datarow.push("ChatId");
              datarow.push("Name");
              datarow.push("Message");
              datarow.push("SentTime");
              var ExhibitorChatData = [];
              ExhibitorChatData.push(datarow);
              console.log("MeetingChatData - " + ExhibitorChatData);

              //-----------------------------------------------------------------------------------------------------------------------

              querySnapshot.forEach((doc) => {
                debugger;
                datarow = [];
                var ChatId =
                  doc.data().ChatId == undefined ? "" : doc.data().ChatId;
                datarow.push('"' + ChatId + '"');
                var userName = (doc.data().Name == undefined
                  ? ""
                  : doc.data().Name.toString()
                ).trim();
                datarow.push('"' + userName + '"');
                var Msg = (doc.data().Message == undefined
                  ? ""
                  : doc
                      .data()
                      .Message.toString()
                      .split("#")
                      .join("")
                      .split(",")
                      .join("")
                ).trim();
                datarow.push('"' + Msg + '"');
                var SentTime =
                  doc.data().CreatedDate == undefined ||
                  doc.data().CreatedDate == null
                    ? "NA"
                    : this.SetTimeByZoneAMPM(
                        new Date(
                          doc.data().CreatedDate.seconds * 1000
                        ).toUTCString(),
                        Session_Event_TZ
                      );

                datarow.push(
                  SentTime.replace(",", "").replace(",", "").replace(",", "")
                );
                ExhibitorChatData.push(datarow);
                debugger;
              });

              //------------------------------------------------------------------------------------------------------------------------
              // debugger;
              let csvContent = "data:text/csv;charset=utf-8,";
              var dt = new Date().toISOString().slice(0, 10);
              ExhibitorChatData.forEach(function (rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
              });
              console.log(csvContent);
              var filename = "ExhibitorChat_" + "_" + dt + ".csv";
              var encodedUri = encodeURI(csvContent);
              var link = document.createElement("a");
              link.setAttribute("href", encodedUri);
              link.setAttribute("download", filename);
              document.body.appendChild(link); // Required for FF

              link.click();
            });
            //=====================================================================================================================================
          }
        });

        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one record to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    getDefaultSettings() {
      this.IsDefaultSettings = true;
      this.ExpoHallBackgroundImageFile = null;
      this.ExpoHallBackgroundImageSrc = null;
      this.expoBoothRadios = "default";
      this.orderByExhibitor = "BoothNo";
      this.settingsData = {
        AllowAerialView: false,
        AllowAttendeeMeetingWithExhibitors: true,
        AllowBusinessCardExchange: true,
        AllowMoreThan1tojoinRepInVideoCall: true,
        AllowbirdView: false,
        DisplayExhibitorContactsOnBooths: true,
        DisplayRoundtablesforExpoBooths: true,
        EnableChatOrEmailwithExhibitor: true,
        EnableEnhancedExpoMode: true,
        EnableExhibitorFilterAndSearchOption: true,
        EnableExhibitorRepVideoCall: true,
        EnableExhibitorShowcaseVideo: true,
        ExpoHallBackgroundImage: null,
        IsEnhancedHotspotting: true,
        JoinTheConversationText:
          "<p>Welcome to {BoothName} Our Reps are here to assist you. You can also contact us on {phone} or visit {BoothWebsite}</p>",
        OrderBy: "BoothNo",
        ShowExhibitorCollateralsForDownload: true,
        ShowRepActiveStatus: true,
        EnableExhibitorAutoPlayBoothVideo: true,
      };
      this.exhibitorSettingsResetKey += 1;
      this.popupActive2 = true;
    },
    getSettings() {
      this.exhibitorSettingsResetKey += 1;
      this.popupActive2 = true;
    },
    getExhibitorType(TypeObj){
      this.popupExhibitorTypeList = false;      
      this.ExhibitorType = null
      this.componentKey += 1; 
      if(TypeObj)
      {
        this.popupAddTypeTitle = "Edit Exhibitor Type"
        this.ExhibitorType = TypeObj
        this.popupAddType = true;
      }
      else
      {
        this.popupAddTypeTitle = "Add Exhibitor Type"
        this.ExhibitorType = {
          TypeId: null,
          TypeName: null,
          BackgroundImg: null
        }
        this.popupAddType = true;
      }
    },
    ManageBoothType(){
      this.popupExhibitorTypeList = true;
      this.$store.dispatch("exhibitorManagement/fetchExhibitorTypes")
    },
    ManageCategory: function () {
      this.fetchCategory();
      this.popupActiveCategory = true;
    },
    addCategory: function () {
      this.errors.clear();
      this.popupActiveCategory = false;
      this.popupActiveAddCategory = true;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    validateBeforeTemplateSave: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.saveTemplate();
        }
      });
    },
    saveTemplate: function () {
      var dt = this.categoryName; // document.getElementById("txtCategory").value;
      debugger;
      console.log("category Name :-" + dt);
      console.log(this.exhTemplate.templateName);
      debugger;
      //-----------------------------------------------------------------------------
      var cn = ls.getSessionEventCollectionName(); ///OA_UAT/BoothDesigns/Templates/2A1wtx9POQHMNWUlJ0PF
      con.eventDB
        .collection("OA_UAT")
        .doc("BoothDesigns")
        .collection("Templates")
        .where("Name", "==", this.exhTemplate.templateName)
        .get()
        .then((querySnapshot) => {
          var tempHtml = "";
          var TemplateName = "";
          querySnapshot.forEach((doc) => {
            debugger;
            tempHtml = doc.data().HtmlCode;
            TemplateName = doc.data().Name;
          });
          //console.log(this.templateData);
          var cn = ls.getSessionEventCollectionName(); ///OA_UAT_C1591904892446E1591907102804/ExhibitorHotspotSettings/Category
          con.eventDB
            .collection(cn)
            .doc("ExhibitorCategories")
            .collection("Category")
            .doc(dt)
            .get()
            .then(function (doc) {
              if (doc.exists) {
                doc.ref.update({
                  // CreatedOn: new Date().toISOString().slice(0, 10),
                  HtmlCode: tempHtml,
                  TemplateName: TemplateName,
                  LastModified: new Date().toISOString().slice(0, 10),
                });
              } else {
                var cRef = con.eventDB
                  .collection(cn)
                  .doc("ExhibitorCategories")
                  .collection("Category")
                  .doc(dt);

                debugger;
                var docObj = new Object();
                docObj.Category = dt;
                docObj.HtmlCode = tempHtml;
                docObj.TemplateName = TemplateName;
                docObj.CreatedOn = new Date().toISOString().slice(0, 10);

                docObj.LastModified = new Date().toISOString().slice(0, 10);

                cRef.set(docObj).then(function () {
                  console.log("sucess");
                });
              }
            });
        });
      this.$vs.notify({
        color: "success",
        position: "top-center",
        title: "Manage Category",
        text: "Category Added successfully.",
      });
      this.categoryName = null;
      this.exhTemplate.templateName = null;
      this.popupActiveAddCategory = false;
      //------------------------------------------------------------------------------
    },
    resetSettings() {
      this.settingsData.JoinTheConversationText = this.JoinTheConversationTexDefault;
    },

    saveSettings() {
      this.$vs.loading();
      if (this.expoBoothRadios == "default") {
        this.settingsData.EnableEnhancedExpoMode = true;
        this.settingsData.AllowAerialView = false;
        this.settingsData.AllowbirdView = false;
      } else if (this.expoBoothRadios == "aerial") {
        this.settingsData.EnableEnhancedExpoMode = false;
        this.settingsData.AllowAerialView = true;
        this.settingsData.AllowbirdView = false;
      } else {
        this.settingsData.EnableEnhancedExpoMode = false;
        this.settingsData.AllowAerialView = false;
        this.settingsData.AllowbirdView = true;
      }
      this.settingsData.OrderBy = this.orderByExhibitor;
      this.$store
        .dispatch("exhibitorManagement/saveSettings", {
          settingsData: this.settingsData,
          ExpoHallBackgroundImageFile: this.ExpoHallBackgroundImageFile,
          IsDefaultSettings: this.IsDefaultSettings,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message,
          });
          this.IsDefaultSettings = false;
          this.popupActive2 = false;
          this.$vs.loading.close();
        });
    },
    addRecord() {
      var addedCount = document.getElementById("exhibitorCount").innerText;
      localStorage.setItem("exhibitorCount", parseInt(addedCount) + 1);
      this.$router.push(`/event/exhibitor/add`).catch(() => {});
    },
    // editRecord () {
    //   this.$router.push(`/event/exhibitor/add/${268}`).catch(() => {})
    // },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all",
      };

      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    GetDateTimeFromSeconds(seconds) {
      //var myObj = $.parseJSON('{"date_created":\""+seconds.toString()+"\"}');
      var myDate = new Date(1000 * seconds);
      //console.log(myDate.toString());
      //console.log(myDate.toLocaleDateString("en-IN"));
      return myDate.toUTCString();
      //return myDate.toLocaleString();
      //return myDate.toLocaleDateString("en-US");
    },
    changeStatus(Status) {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length) {
        this.$vs.loading();
        this.$store
          .dispatch("exhibitorManagement/changeStatus", {
            data: selectedRows,
            Status: Status,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Status",
              text: res.message,
            });
            this.gridApi.deselectAll();
            this.$vs.loading.close();
            this.$store.dispatch("exhibitorManagement/fetchExhibitors");
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          title: "Status",
          text: "Please Select a Row",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
    UploadExhibitor: function () {
      var files = document.getElementById("exhibitor_file").files;
      bu.initVueComps(this.$vs);
      bu.StartUploadPrecss(files, "exhibitor");
    },
    onSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      this.gridSelectedRows = selectedRows.length;
    },
    fetchCategory() {
      this.$store
        .dispatch("exhibitorManagement/fetchCategory")
        .then((res) => {
          this.categoryList = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    gcd(a, b) {
      return b == 0 ? a : vm.gcd(b, a % b);
    },
    update_avatar(input, fileDimension, fieldName, srcName) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const file = input.target.files[0];
        const metadata = {
          contentType: file.type,
        };

        const validImageTypes = ["image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileDimension.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          if (this.width == dimension[0] && this.height == dimension[1]) {
            let r = vm.gcd(this.width, this.height);
            if (this.width / r == 16 && this.height / r == 9) {
              vm[fieldName] = file;
              const reader = new FileReader();
              reader.onload = (e) => {
                vm[srcName] = e.target.result;
              };
              reader.readAsDataURL(input.target.files[0]);
            } else {
              alert("File ratio does not match: 16:9");
            }
          } else {
            alert("File dimension does not match " + fileDimension);
            return false;
          }
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    OpenExhibitorExportModal() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length > 0) {
        if (selectedRows.length > 10) {
          this.$vs.dialog({
            type: "alert",
            color: "warning",
            title: "Download Exhibitor Reports",
            text: "Please Download 10 report at a time. ",
            acceptText: "OK",
          });
        } else {
          this.popupActiveExhibitorExport = true;
          document.getElementById("modalExhibitorSelected").innerText =
            "Exhibitor(s) Selected : " + selectedRows.length;
        }
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Exhibitor Reports",
          text: "Please select atleast one Exhibitor to download. ",
          acceptText: "OK",
        });
      }
    },
    getExhibitorVisits(boothName) {
      var datarow = [];
      var timeZone = [];
      var exhibitor = [];

      timeZone.push("Report Exported In ");
      var timezone = Session_Event_TZ == undefined ? "" : Session_Event_TZ;
      timeZone.push('"' + timezone + " Time Zone" + '"');

      exhibitor.push("Booth Name");
      var booth = boothName;
      exhibitor.push('"' + booth + '"');

      datarow.push("Name");
      datarow.push("Email");
      datarow.push("Time");
      var userLoginData = [];
      userLoginData.push(datarow);

      var TimeZoneHeader = [];
      TimeZoneHeader.push(timeZone);

      var ExhibitorHeader = [];
      ExhibitorHeader.push(exhibitor);

      this.ExhibitorList.map((row1) => {
        datarow = [];
        var name = row1.userName == undefined ? "" : row1.userName;
        datarow.push('"' + name + '"');
        var email = row1.userEmail == undefined ? "" : row1.userEmail;
        datarow.push('"' + email + '"');
        var date = row1.viewDtm == undefined ? "" : '"' + row1.viewDtm + '"';
        datarow.push(date);

        userLoginData.push(datarow);
      });
      let csvContent = "data:text/csv;charset=utf-8,";
      var dt = new Date().toISOString().slice(0, 10);
      TimeZoneHeader.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      ExhibitorHeader.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      userLoginData.forEach(function (rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      var filename = "ExhibitorData" + "_" + boothName + "_" + dt + ".csv";
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      //link.setAttribute("id", "Participance_RT_" + row.TableId);
      link.setAttribute("download", filename);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    fetchExhibitorVisitorList() {
      this.$vs.loading();
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      selectedRows.map((row) => {
        this.$store
          .dispatch(
            "exhibitorManagement/fetchExhibitorVisitorReport",
            row.ExhibitorId
          )
          .then((res) => {
            this.ExhibitorList = res.data;
            this.$vs.loading.close();
            this.getExhibitorVisits(row.Name);
          })
          .catch((err) => {
            console.error(err);
            this.$vs.loading.close();
          });
      });
    },
    turnPluginForChatOn(data) {
      if (!data == true) {
        debugger;
        this.data_local.OneToOneChat = !data;
        this.data_local.defaultChatMsg = "Hi 👋";
        this.$store
          .dispatch("eventManagement/addUpdatePlugin", {
            data: this.data_local,
          })
          .then((res) => {
            if (res.status == 200) {
              console.log("Plugins Updated");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    saveExhibitorSettingsData(){
        this.settingsData = {
        DefaultSettingsLoaded: true
      };
    },
    getMailTpl() {
      let selectedRows = this.gridApi.getSelectedRows();
      if (selectedRows.length > 100) {
        this.$vs.dialog({
          type: "alert",
          position: "top-center",
          color: "warning",
          //title: "Status",
          text: "Mail cannot be sent more than 100 attendee at a time!",
          acceptText: "OK",
        });
      } else {
        this.$vs.loading();
        this.welcomeMailText = "Loading...";
        this.$store
          .dispatch("exhibitorManagement/getMailTemplate")
          .then((res) => {
            this.welcomeMailText = res.html;
            this.welcomeMailSubject = res.subject;
            this.sourcehtml = res.sourcehtml;
            this.$vs.loading.close();
            this.popupActiveMail = true;
          });
      }
    },
    sendMail() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      //console.log(selectedRows);
      ///than you can map your selectedRows
      // selectedRows.map((row) => {
      //   //console.log(row);
      //   this.mailRecepients.push(row.SpeakerId);
      // });
      for(let row of selectedRows){
        if(row.MappedContacts){
          for(let user of row.MappedContacts){
            if(user.AttendeeId && user.IsAdmin)
              this.mailRecepients.push(user.AttendeeId);
          }
        }
      }
      if (this.mailRecepients.length && this.welcomeMailSubject) {
        this.$vs.loading();
        this.$store
          .dispatch("exhibitorManagement/sendMail", {
            data: this.mailRecepients,
            subject: this.welcomeMailSubject,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              title: "Mail Sent",
              text: res.message,
            });
            this.mailRecepients = [];
            this.gridApi.deselectAll();
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        //alert("Please Select Recepient!");
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Recepient",
          text: "Please select exhibitor which contains mapped contacts! ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
      this.popupActiveMail = false;
    },
    saveMail() {
      this.$vs.loading();
      this.$store
        .dispatch("exhibitorManagement/saveMail", {
          sourcehtml: this.sourcehtml,
          subject: this.welcomeMailSubject
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            title: "Mail Save",
            text: res.message,
          });          
          this.$vs.loading.close();
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay();
    this.gridApi = this.gridOptions.api;
    this.gridCategoryApi = this.gridOptionsCategory.api;
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
    //-----------GEt template data------------------------------------------------------------------------------

    var cn = ls.getSessionEventCollectionName(); ///OA_UAT/BoothDesigns/Templates/2A1wtx9POQHMNWUlJ0PF
    con.eventDB
      .collection("OA_UAT")
      .doc("BoothDesigns")
      .collection("Templates")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          if(doc.data().ImagePath && doc.data().PSDPath){
            this.templateData.push({
              id: doc.data().Name,
              templateName: doc.data().Name,
              ImagePath: doc.data().ImagePath ? doc.data().ImagePath : null,
            });
          }
        });
        //console.log(this.templateData);
      });

    //-----------------------------------------------------------------------------------------------------------
  },
  created() {
    vm = this;
    if (!moduleExhibitorManagement.isRegistered) {
      this.$store.registerModule(
        "exhibitorManagement",
        moduleExhibitorManagement
      );
      moduleExhibitorManagement.isRegistered = true;
    }
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    this.$vs.loading();
    this.$store.dispatch("exhibitorManagement/getSettings").then((res) => {
      this.settingsData = res;
      this.$store
        .dispatch("exhibitorManagement/fetchExhibitors")
        .then((res) => {
          this.pageLoaded = true;
          this.$vs.loading.close();
        });
    });

    this.fetchCategory();
    if (!moduleroundtableManagement.isRegistered) {
      this.$store.registerModule(
        "roundtableManagement",
        moduleroundtableManagement
      );
      moduleroundtableManagement.isRegistered = true;
    }
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.booth-toggles {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.booth-radios {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>